import useAuth from '@core/auth/useAuth';
import axios from '@axios';

const { auth } = useAuth(axios, {});
export default auth;
